import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton } from 'core/components';
import { PreviewLayout, PageFooter } from 'core/layouts';
import { toDate } from 'core/utils';
import _ from 'lodash';

function SalesOrderPreviewTemplate({ salesOrderPreviewViewStore, t }) {
    const {
        rootStore,
        item,
        loaderStore,
        brightreeBaseUrl
    } = salesOrderPreviewViewStore;

    const dateOfService = item ? _.first(item.salesOrderItems) : null;
    const salesOrderItems = item ? item.salesOrderItems.map(item =>
        <div className="row" key={item.brightreeDetailID}>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.ITEM_ID')}</div>
                <span>
                    <React.Fragment>{item.itemId}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.ITEM_NAME')}</div>
                <span>
                    <React.Fragment>{item.itemName}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.PROCEDURE_CODE')}</div>
                <span>
                    <React.Fragment>{item.procCode}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.QUANTITY')}</div>
                <span>
                    <React.Fragment>{item.quantity}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.BILL_QUANTITY')}</div>
                <span>
                    <React.Fragment>{item.billQuantity}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.NOTE')}</div>
                <span>
                    <React.Fragment>{item.note ? item.note : "N/A"}</React.Fragment>
                </span>
            </div>
        </div>
        ) : [];

    return (
        <PreviewLayout store={salesOrderPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="card card--form card--primary card--med">
            <div className="card__header u-mar--bottom--med">
                    {item ? <a target='_blank' href={brightreeBaseUrl + 'OrderEntry/frmSOOrderRO.aspx?SalesOrderKey='+item.brightreeId+'&ShowAck=0&Edit=0'}>
                        <BaasicButton className='btn btn--base btn--ghost u-mar--left--auto' label={'Order link'}/></a> : null}
                    </div>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                        <h4 className="form__title form__title--preview">Orders</h4>
                        <div className="row">
                        <div className="form__group col col-sml-12 col-lrg-3">
                            <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.ORDER_ID')}</div>
                                <span>
                                    {item ? <React.Fragment>{item.brightreeId}</React.Fragment> : null}
                                </span>
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-3">
                            <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.REFERENCE')}</div>
                                <span>
                                    {item ? <React.Fragment>{item.salesOrderGeneralInfo.reference ? item.salesOrderGeneralInfo.reference : 'N/A'}</React.Fragment> : null}
                                </span>
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-3">
                            <div className="form__group__label is-preview">{t('ORDERS.PREVIEW.DATE_OF_SERVICE')}</div>
                                <span>
                                    {item ? <React.Fragment>{toDate(dateOfService.serviceDate)}</React.Fragment> : null}
                                </span>
                        </div>
                    </div>
                    </div>
                    <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                        <h4 className="form__title form__title--preview">Items</h4>
                        {salesOrderItems}
                    </div>
                </div>
            </div>
            <PageFooter>
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label={('LIST_LAYOUT.BACK_BUTTON')}
                    onClick={() => rootStore.routerStore.goBack()}
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                />
            </PageFooter>
        </PreviewLayout>
    )
}

SalesOrderPreviewTemplate.propTypes = {
    salesOrderPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(SalesOrderPreviewTemplate);
